import useStore from './useStore';

const useUserStore = () => {
    const { userStore } = useStore();

    return userStore;
};

export default useUserStore;
